var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolkswagen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_3111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 39.525C11.375 39.525 3.05 31.125 3.05 21C3.05 18.9 3.425 16.875 4.1 14.925L14.9 35.925C15.05 36.225 15.2 36.45 15.575 36.45C15.95 36.45 16.1 36.225 16.25 35.925L21.275 24.75C21.35 24.6 21.425 24.525 21.5 24.525C21.65 24.525 21.65 24.675 21.725 24.75L26.825 35.925C26.975 36.225 27.125 36.45 27.5 36.45C27.875 36.45 28.025 36.225 28.175 35.925L38.975 14.925C39.65 16.8 40.025 18.825 40.025 21C39.95 31.125 31.625 39.525 21.5 39.525ZM21.5 16.2C21.35 16.2 21.35 16.05 21.275 15.975L15.5 3.525C17.375 2.85 19.4 2.475 21.5 2.475C23.6 2.475 25.625 2.85 27.5 3.525L21.725 15.975C21.65 16.05 21.65 16.2 21.5 16.2ZM15.425 29.7C15.275 29.7 15.275 29.55 15.2 29.475L5.75 11.325C7.4 8.625 9.8 6.375 12.575 4.8L19.25 19.2C19.4 19.5 19.55 19.575 19.775 19.575H23.225C23.45 19.575 23.6 19.5 23.75 19.2L30.35 4.8C33.125 6.375 35.525 8.625 37.175 11.325L27.8 29.475C27.725 29.625 27.65 29.7 27.575 29.7C27.425 29.7 27.425 29.55 27.35 29.475L23.75 21.525C23.6 21.225 23.45 21.15 23.225 21.15H19.775C19.55 21.15 19.4 21.225 19.25 21.525L15.65 29.475C15.575 29.55 15.575 29.7 15.425 29.7ZM21.5 42C33.125 42 42.5 32.625 42.5 21C42.5 9.375 33.125 0 21.5 0C9.875 0 0.5 9.375 0.5 21C0.5 32.625 9.875 42 21.5 42Z",
    fill: "#0F0F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_3111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolkswagen);
export default __webpack_public_path__ + "static/media/volkswagen.6f6126f1596122e7a8321d26d5efa0b2.svg";
export { ForwardRef as ReactComponent };